import axios from "axios";
import { getPhoneNumberToken, getUserToken, deviceInfo } from "helpers";
import { endPoints, axiosErrorHandler, responseHandler } from "./endpoints";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { ToasterChild } from "component/Common/ToasterContainer";

export const sendOtp = async (data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.SEND_OTP}`,
      data,
      headers: {
        "App-Type": deviceInfo(),
      },
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};

export const verifyOtp = async (data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.VERIFY_OTP}`,
      headers: {
        Authorization: getPhoneNumberToken(),
        "App-Type": deviceInfo(),
      },
      data,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};

export const resendOtp = async (data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.RESEND_OTP}`,
      headers: {
        Authorization: getPhoneNumberToken(),
        "App-Type": deviceInfo(),
      },
      data,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};

export const getSignupDetails = async (from, location = null) => {
  try {
    let response = await axios({
      method: "get",
      url: `${endPoints.auth.SIGNUP_DETAILS}`,
      headers: {
        Authorization:
          from === "signup" ? getPhoneNumberToken() : getUserToken(),
        "App-Type": deviceInfo(),
      },
    });

    let respData = responseHandler(response, false);
    return respData;
  } catch (err) {
    if (location)
      return axiosErrorHandler(
        err,
        false,
        location?.pathname + location?.search,
      );
    return axiosErrorHandler(err);
  }
};
export const signup = async (data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.SIGNUP}`,
      headers: {
        Authorization: getPhoneNumberToken(),
        "App-Type": deviceInfo(),
      },
      data,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    toast(
      <ToasterChild success={false} message={err?.response?.data?.message} />,
    );
    return axiosErrorHandler(err);
  }
};

export const logout = async () => {
  try {
    const response = await axios({
      method: "post",
      url: `${endPoints.auth.LOGOUT}`,
      headers: {
        Authorization: getUserToken(),
        "App-Type": deviceInfo(),
      },
    });
    if (response) {
      // axiosInstance.defaults.headers.common["Authorization"] = "";
      localStorage.clear();
      window.location.reload(true);

      // console.log('object5')
    }
  } catch (error) {
    console.error("Error logout:", error);
  }
};

export const sendEmailOtp = async (data, section) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.SEND_EMAIL_OTP}`,
      headers: {
        Authorization:
          section === "signUp" ? getPhoneNumberToken() : getUserToken(),
        "App-Type": deviceInfo(),
      },
      data,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};

export const resendOtpAgain = async (data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.auth.SEND_RESEND_OTP}`,
      headers: {
        Authorization: getPhoneNumberToken(),
        "App-Type": deviceInfo(),
      },
      data,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};

export const resendEmailVerification = async () => {
  try {
    let response = await axios({
      method: "post",
      url: `${endPoints.user.RESEND_EMAIL_VERIFICATION}`,
      headers: {
        Authorization: getUserToken(),
        "App-Type": deviceInfo(),
      },
      showToast: false,
    });

    let respData = responseHandler(response);
    return respData;
  } catch (err) {
    return axiosErrorHandler(err);
  }
};
